<textarea [readonly]="element._get('readOnly')" [attr.maxlength]="element._get('maxLength')" [value]="element._get('data')"></textarea>

